<template>
  <headroom>
    <header>
      <div class="appHeader">
        <div class="header-container">
          <i class="hamburgerMenu" @click="openSideMenu">
            <img style="width: 25px; height: 21px;" src="@/assets/side-hamburger.png" alt>
          </i>
          <div class="menu-items">
            <router-link to="/">
              <span id="logo">
                <img class="io-logo" src="@/assets/header/io-logo.png" alt>
              </span>
            </router-link>
            <ul class="product-list">
              <li>
                <router-link title="Switcher" to="/switcher">Switcher</router-link>
              </li>
              <li>
                <router-link title="Linker" to="/linker">Linker</router-link>
              </li>
              <li>
                <router-link title="Checker" to="/checker">Checker</router-link>
              </li>
            </ul>
          </div>
          <div class="menu-items">
            <!-- <span @click="goPage('cash')" style="cursor: pointer" class="go-page">I/O Cash 알아보기</span> -->
            <span @click="goPage('freetrial')" style="cursor: pointer" class="go-page">무료체험 알아보기</span>
            <!-- <span @click="goPage('campaign')" style="cursor: pointer" class="go-page">프로모션</span> -->
            <div @click="goToCart" style="cursor: pointer">
              <i>
                <img style="width: 30px; height: 30px;" src="@/assets/header/btn-cart.png" alt>
              </i>
              <span class="cartItems" v-show="numberOfCartItems">{{numberOfCartItems}}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  </headroom>
</template>

<script>
import { headroom } from 'vue-headroom'
const alertOptions = { title: '', size: 'sm' }

export default {
  name: 'app-header',
  components: { headroom },
  methods: {
    openSideMenu: function () {
      this.$store.commit('toggleSideMenu')
    },
    goToCart: function () {
      if (this.$store.state.cartItems.length === 0) {
        this.$dialogs.alert('장바구니가 비어있습니다.', alertOptions)
      } else {
        this.$router.push('/cart')
      }
    },
    goPage: function (page) {
      switch (page) {
        case 'cash':
          this.$router.push({ name: 'Cash' })
          break
        case 'freetrial':
          this.$router.push({ name: 'FreeTrial' })
          break
        case 'campaign':
          this.$router.push({ name: 'Promotion' })
          break
      }
    }
  },
  computed: {
    numberOfCartItems () {
      return this.$store.state.numberOfCartItems
    }
  }
}
</script>

<style scoped>
.headroom--top {
    z-index: 100000 !important;
}

.headroom--pinned {
    z-index: 100000 !important;
}
.appHeader {
    height: auto;
    background-color: #fff;
    padding: 20px;
}
.appHeader .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.appHeader .header-container .go-page {
    display: none;
}
.appHeader .header-container ul {
    display: none;
    margin: 0;
    padding: 0;
    list-style: none;
}
.appHeader .header-container ul a {
    color: #3d4953;
    text-decoration: none;
    display: block;
    padding-right: 20px;
}
.appHeader .header-container .menu-items #logo img {
    width: 36px;
    height: 21px;
}
.desktop #logo {
    padding: 10px;
}

.cartItems {
    background-color: #6f97fa;
    border: solid 2px #ffffff;
    color: #ffffff;
    font-size: 12px;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    top: 12px;
    margin-left: -10px;
}

/* desktop */
@media (min-width: 768px) {
    .appHeader {
        padding: 18px 30px 18px 30px;
    }
    .appHeader .io-logo {
        width: 36px;
        height: 21px;
    }
    .appHeader .hamburgerMenu {
        display: none;
    }
    .appHeader .header-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;
    }

    .appHeader .header-container ul {
        display: flex;
    }

    .appHeader .header-container .menu-items {
        display: flex;
        align-items: center;
    }

    .appHeader .header-container .menu-items .product-list {
        margin-left: 35px;
    }
    .appHeader .header-container .menu-items .product-list a {
        display: inline-block;
        text-align: center;
    }
    .appHeader .header-container .menu-items .product-list a:hover {
        font-weight: bold;
    }
    .appHeader .header-container .menu-items .product-list a::after {
        display: block;
        content: attr(title);
        font-weight: bold;
        height: 0;
        overflow: hidden;
        visibility: hidden;
    }
    .appHeader .header-container .menu-items .go-page {
        display: block;
        margin-right: 20px;
    }
    .appHeader .header-container .menu-items .go-page:hover {
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue